export default {
  inject: {
    form: {
      from: "form",
      default: null
    }
  },
  props: {
    rules: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    errorBucket: []
  }),
  created() {
    this.form && this.form.register(this);
    this.unwatch = this.$watch("value", this.validate, { immediate: true });
  },
  beforeDestroy() {
    this.form && this.form.unregister(this);
    this.unwatch();
  },
  computed: {
    hasError() {
      return this.errorBucket.length > 0;
    }
  },
  methods: {
    validate() {
      const errorBucket = [];

      for (const rule of this.rules) {
        const valid = typeof rule === "function" ? rule(this.value) : rule;

        if (valid === false || typeof valid === "string") {
          errorBucket.push(valid || "");
        } else if (typeof valid !== "boolean") {
          console.error(
            `Rules should return a string or boolean, received '${typeof valid}' instead`
          );
        }
      }
      this.errorBucket = errorBucket;
      return errorBucket.length === 0;
    }
  }
};
